import { Injectable, OnDestroy } from '@angular/core';
import { preventPageScrollOverNgDropdownPanel } from '@app/core/utils/ng-dropdown-panel-scroll';

/**
 * App-wide: wheel over an open ng-select panel scrolls the options, not the page.
 * Stops capture-phase page-scroll listeners from closing the dropdown mid-scroll.
 */
@Injectable({
  providedIn: 'root',
})
export class NgSelectDropdownScrollGuard implements OnDestroy {
  private listening = false;

  startWatching(): void {
    if (this.listening || typeof document === 'undefined') {
      return;
    }

    document.addEventListener('wheel', this.onWheel, {
      capture: true,
      passive: false,
    });
    this.listening = true;
  }

  stopWatching(): void {
    if (!this.listening || typeof document === 'undefined') {
      return;
    }

    document.removeEventListener('wheel', this.onWheel, true);
    this.listening = false;
  }

  ngOnDestroy(): void {
    this.stopWatching();
  }

  private readonly onWheel = (event: WheelEvent): void => {
    preventPageScrollOverNgDropdownPanel(event);
  };
}
